<app-chip-button (click)="openDialog()" [minWidth]="'220px'">Contact us</app-chip-button>
